/* eslint-disable max-lines-per-function */
import React, { useRef, useState,useEffect } from 'react';
import { Growl } from 'primereact/growl';
import Vincular from '../components/Vincular.jsx';
import linksTvService from '../../../../services/tvs/linksTvService';
import VinculoService from '../../../../services/tvs/vincular-link-grupo';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens'; 

export function VincularLinks({
    rowSelecionada,
    modalVincularLinkAberto,
    setModalVincularLinkAberto
    //setRecarregarDataTable
}) {
    const [gruposVinculados,setGruposVinculados] = useState([]);
    const [gruposDisponivel,setGruposDisponiveis] = useState([]);
    const mensagemToast = useRef(null);

    const limpaGrupos = () => {
        setGruposDisponiveis([]);
        setGruposVinculados([]);
    };

    const onSubmitVincularGrupos = async (fonte,alvo) => {
        try{
            await VinculoService.postLinksVinculadosGrupoId(rowSelecionada?.rowData?.id, alvo.map(a => a.id));
            await VinculoService.deleteLinksVinculadosGrupoId(rowSelecionada?.rowData?.id, fonte.map(a => a.id));
            mostrarMensagemSucesso(mensagemToast,'Alterado com sucesso!');
            setModalVincularLinkAberto(false);
            limpaGrupos();
        } catch (e) {
            mostrarMensagemErro(mensagemToast,'Não foi possível alterar os dados! Tente novamente mais tarde.');
        }
    };

    useEffect(() => {
        (async () => {
            const responseDataLinks = await linksTvService.getLinks();
            const responseDataLinksV = await VinculoService.getLinksVinculadosGrupoId(rowSelecionada?.rowData?.id);
                                            
            function selecionar(currentValue, index, arr, e) {
                return currentValue.idLink != e.id;
            }
            
            const ZeloTvLink = [];

            responseDataLinksV.forEach(e=> ZeloTvLink.push(e.ZeloTvLink) );
           
            setGruposVinculados(ZeloTvLink);
            setGruposDisponiveis(responseDataLinks.filter(e => 
                responseDataLinksV.every((c,i,a)=>selecionar(c,i,a,e))));
        })();
    }, [rowSelecionada]);
        
    return (
        <>
            <Growl ref={mensagemToast} />
            <Vincular 
                onSubmitBotaoAcao={onSubmitVincularGrupos}
                setFonte={setGruposDisponiveis} 
                setAlvo={setGruposVinculados} 
                fonteDados={gruposDisponivel} 
                titleModal={'Vincular links'} 
                fonteTitulo={'Links não vinculados'} 
                alvoTitulo={'Links vinculados'} 
                alvoDados={gruposVinculados} 
                openModal={modalVincularLinkAberto} 
                setOpenModal={setModalVincularLinkAberto}
                limpaGrupos={limpaGrupos}/>
            
        </>
    );
}
